<kodit-table
  [tableConfig]="tableConfig"
  [paginatedData]="paginatedData!"
  [isTableLoading]="isLoading"
>
</kodit-table>
